import React, {
  useState,
  Fragment,
  useCallback,
  Suspense,
  useEffect,
} from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Card,
  CardBody,
  CardHeader,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Button,
  Col,
  Table
} from "reactstrap";
import { Breadcrumbs, Btn, H4 } from "../../../../../AbstractElements";
import Loader from "../../../../../Layout/Loader";
import DataTable from "react-data-table-component";
// import { prescriptiontabledata, tableColumns } from '../../../../../Data/Prescription';
import { useLocation, useNavigate } from "react-router";
import { toast } from "react-toastify";
import SweetAlert from "sweetalert2";
import RequiredField, { Submit, Cancel } from "../../../../../Constant";
import {
  CreatePatientPrescription,
  DeletePatientPrescription,
  PatientPrescriptionList,
  PharmacyCategoryList,
  PharmacyList,
  UpdatePatientPrescription,
} from "../../../../../apiController";
import { Navigator } from "../../../../../Data/Table/Defaultdata";

const style2 = { width: 60, fontSize: 14, padding: 4 };
const Prescription = ({ permission }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { data } = location.state || {};
  const [prescriptionForm, setPrescriptionForm] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      pharmacycategory: "",
      medicinename: "",
      quantity: "",
      duration: "",
      beforefood: false,
      afterfood: false,
      morning: false,
      afternoon: false,
      evening: false,
      night: false,
      id: ""
    },
  });

  const [selectedRows, setSelectedRows] = useState([]);
  const [patientPrecriptionList, setPatientPrecriptionList] = useState([]);
  const [toggleDelet, setToggleDelet] = useState(false);
  const [category, setCategory] = useState([]);
  const [pharmacy, setPharmacy] = useState([]);
  const [filteredPharmacy, setFilteredPharmacy] = useState([]);

  const selectedCategory = watch("pharmacycategory");

  const [formdata, setFormdata] = useState({});

  const [selectedPrescription, setSelectedPrescription] = useState(null);

const handleEditClick = (prescription) => {
  setSelectedPrescription(prescription);
  setPrescriptionForm(!prescriptionForm)
console.log(prescription)
  // Set form values with the selected prescription data
  setValue('pharmacycategory', prescription.pharmacycategory || '');
  setValue('medicinename', prescription.prescription_subcategory_id || '');
  setValue('quantity', prescription.quantity || '');
  setValue('duration', prescription.duration || '');
  setValue('beforefood', prescription.before_food === "yes");
  setValue('afterfood', prescription.after_food === "yes");
  setValue('morning', prescription.morning === "yes");
  setValue('afternoon', prescription.afternoon === "yes");
  setValue('evening', prescription.evening === "yes");
  setValue('night', prescription.night === "yes");
};


const prescriptiontabledata = patientPrecriptionList.map((row, rowIndex) =>({
 
    ind: rowIndex + 1, 
    date: row.date,
    id: row.prescription.map((prep) => prep.id),
    prescriptionname:  row.prescription.map((prep) => prep.sub_name),
    quantity: row.prescription.map((prep) => prep.quantity),
    duration: row.prescription.map((prep) => prep.duration),
    maen: row.prescription.map((prep) => `${prep.morning === "yes" ? 1 : 0}-${
      prep.afternoon === "yes" ? 1 : 0
    }-${prep.evening === "yes" ? 1 : 0}-${prep.night === "yes" ? 1 : 0}`),
    intake: row.prescription.map((prep) => prep.after_food === null ? prep.before_food : prep.after_food ),
    total: row.sum,
    due: row.prescription.map((prep) => prep.already_paid === row.sum ? "No-Due" : "In-Due"),
    pay: row.prescription.map((prep) =>prep.already_paid === null ? "Not Paid" : prep.already_paid),
    action: row.prescription.map((prep) =>(
      <span>
        <Btn
          attrBtn={{
            style: style2,
            color: "info",
            className: "btn btn-xs",
            type: "button",
            onClick: () => handleEditClick(prep),
          }}
        >
          Edit
        </Btn>
      </span>
    )),
    viewprescription: (
      <span>
        <Navigator
          to={`${process.env.PUBLIC_URL}/prescriptioninvoice/:layout`}
          params={{ rowData: row, data: data, view: "view" ,btn: "view" }}
        />
      </span>
    ),
    viewinvoice: (
      <span>
        <Navigator
          to={`${process.env.PUBLIC_URL}/prescriptioncheckout/:layout`}
          params={{ rowData: row,data: data, permission: permission, btn: "Invoice" }}
        />
      </span>
    ),
  }));

  // const prescriptiontabledata = patientPrecriptionList.flatMap(
  //   (row, rowIndex) =>
  //     row.prescription.map((prep, prepIndex) => {
  //       const createdDate = new Date(prep.created_at);
  //       const formattedDate = createdDate.toISOString().split("T")[0];

  //       return {
  //         id: prep.id,
  //         ind: prepIndex + 1,
  //         date: formattedDate,
  //         prescriptionname: prep.sub_name,
  //         quantity: prep.quantity,
  //         duration: prep.duration,
  //         maen: `${prep.morning === "yes" ? 1 : 0}-${
  //           prep.afternoon === "yes" ? 1 : 0
  //         }-${prep.evening === "yes" ? 1 : 0}-${prep.night === "yes" ? 1 : 0}`,
  //         intake: prep.after_food === null ? prep.before_food : prep.after_food,
  //         total: prep.total_amt,
  //         due: prep.paid_amt === prep.total_pay_amt ? "No-Due" : "In-Due",
  //         // status: prep.status,
  //         pay: prep.paid_amt === null ? "Not Paid" : prep.paid_amt,
  //         action: (
  //           <span>
  //             <Btn
  //               attrBtn={{
  //                 style: style2,
  //                 color: "info",
  //                 className: "btn btn-xs",
  //                 type: "button",
  //                 onClick: () => handleEditClick(prep),
  //               }}
  //             >
  //               Edit
  //             </Btn>
  //           </span>
  //         ),
  //         viewprescription: (
  //           <span>
  //               {/* <Btn attrBtn={{ style: style2, color: 'danger', className: 'btn btn-xs', type: 'button' }}>Delete</Btn> */}
  //               <Navigator to={`${process.env.PUBLIC_URL}/prescriptioninvoice/:layout`} params={{ rowData: prep, data: data, btn: "view" }}/>
  //             </span>
  //         ),
  //         viewinvoice: (
  //           <span>
  //           {/* <Btn attrBtn={{ style: style2, color: 'danger', className: 'btn btn-xs', type: 'button' }}>Delete</Btn> */}
  //           <Navigator to={`${process.env.PUBLIC_URL}/prescriptioncheckout/:layout`} params={{ rowData: prep,  btn: "Pay"}}/>
  //         </span>
  //         ),
  //         // budget: '$3142.00',
  //       };
  //     })
  // );

  const tableColumns = [
    {
      name: "#",
      selector: (row) => row["ind"],
      sortable: true,
      center: true,
    },
    {
      name: "Date",
      selector: (row) => row["date"],
      sortable: true,
      center: true,
    },
    {
      name: "Prescription Name",
      selector: (row) => row["prescriptionname"],
      sortable: true,
      center: true,
    },
    {
      name: "Quantity",
      selector: (row) => row["quantity"],
      sortable: true,
      center: true,
    },
    {
      name: "Duration",
      selector: (row) => row["duration"],
      sortable: true,
      center: true,
    },
    {
      name: "M - A - E - N",
      selector: (row) => `${row.maen}`,
      sortable: true,
      center: true,
    },
    {
      name: "Intake",
      selector: (row) => `${row.intake}`,
      sortable: true,
      center: true,
    },
    {
      name: "Total",
      selector: (row) => `${row.total}`,
      sortable: true,
      center: true,
    },
    {
      name: "Due",
      selector: (row) => `${row.due}`,
      sortable: true,
      center: true,
    },
    //   {
    //     name: 'Status',
    //     selector: row => `${row.status}`,
    //     sortable: true,
    //     center: true,
    // },
    {
      name: "Paid Amt",
      selector: (row) => `${row.pay}`,
      sortable: true,
      center: true,
    },
    {
      name: "Action",
      selector: (row) => row["action"],
      sortable: false,
      center: true,
    },
    {
      name: "View Prescription",
      selector: (row) => row["viewprescription"],
      sortable: false,
      center: true,
    },
    {
      name: "View Invoice",
      selector: (row) => row["viewinvoice"],
      sortable: false,
      center: true,
    },
  ];
  

  const formatFormData = (formdata) => ({
    category_id: formdata.pharmacycategory,
    prescription_subcategory_id: formdata.medicinename,
    patient_id: data.id,
    quantity: formdata.quantity,
    morning: formdata.morning ? "yes" : "no",
    afternoon: formdata.afternoon ? "yes" : "no",
    evening: formdata.evening ? "yes" : "no",
    night: formdata.night ? "yes" : "no",
    before_food: formdata.beforefood ? "yes" : "no",
    after_food: formdata.afterfood ? "yes" : "no",
    duration: formdata.duration,
  });
  
  const onSubmit = (formdata) => {
    const formattedData = formatFormData(formdata);
  
    if (selectedPrescription) {
      const updateData = { ...formattedData, id: selectedPrescription.id };
      console.log('Update Data:', updateData);
      updatePatientPrescription(updateData);
      setSelectedPrescription(null)
    } else {
      console.log('Create Data:', formattedData);
      createPrescription(formattedData);
    }
  };

  const createPrescription = async (prep) => {
    setIsSubmitting(true);
    try {
      const response = await CreatePatientPrescription(prep);
      if (response.status === true) {
        toast.success("Created Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      reset();
      setIsSubmitting(false);
      setSelectedPrescription(null)
      fetchPatientPrescription(patientId)
      setPrescriptionForm(!prescriptionForm)
    }
  };
  const updatePatientPrescription = async (prep) => {
    setIsSubmitting(true);
    try {
      const response = await UpdatePatientPrescription(prep);
      if (response.status === true) {
        toast.success("Created Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      reset();
      setIsSubmitting(false);
      setSelectedPrescription(null)
      fetchPatientPrescription(patientId)
      setPrescriptionForm(!prescriptionForm)
    }
  };

  const [searchKeyword, setSearchKeyword] = useState("");
  const handleSearchKeyword = (keyword) => {
    setSearchKeyword(keyword);
    // searchMember(keyword);
  };

  const patientId = data.id;
  useEffect(() => {
    // console.log(data)
    // console.log(data.id)
    fetchPatientPrescription(patientId);
  }, []);

  const fetchPatientPrescription = async (id) => {
    const response = await PatientPrescriptionList({ patient_id: id });
    if (response.status === true) {
      const prescriptionData = response.data;
      console.log(prescriptionData);
      setPatientPrecriptionList(prescriptionData);
    }
  };

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleDelete = async () => {
    const result = await SweetAlert.fire({
      title: "Are you sure you want to delete?",
      cancelButtonText: "No!",
      confirmButtonText: "Yes!",
      reverseButtons: true,
      showCancelButton: true,
    });

    if (result.isConfirmed) {
      try {
        const selectedIds = selectedRows.map((row) => row.id);
        await Promise.all(
          selectedIds.map((id) => DeletePatientPrescription(id))
        );
        setSelectedRows([]);
        toast.success("Deleted Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      } catch (error) {
        toast.error("An error occurred!", {
          position: toast.POSITION.TOP_CENTER,
        });
      } finally {
        fetchPatientPrescription(patientId);
      }
    }
  };

  const fetchPharmacyCategory = async () => {
    const response = await PharmacyCategoryList();
    if (response.status === true) {
      setCategory(response.data);
    }
  };

  useEffect(() => {
    fetchPharmacyCategory();
    fetchPharmacy();
  }, []);

  useEffect(() => {
    if (selectedCategory) {
      setFilteredPharmacy(
        pharmacy.filter((p) => p.category_id === Number(selectedCategory))
      );
    } else {
      setFilteredPharmacy(pharmacy);
    }
  }, [selectedCategory, pharmacy]);

  const fetchPharmacy = async () => {
    const response = await PharmacyList();
    if (response.status === true) {
      setPharmacy(response.data);
    }
  };

  // console.log(prescriptiontabledata)
  return (
    <Suspense fallback={<Loader />}>
      <Card>
      {permission?.create_access && <CardHeader className="card-no-border">
          <div className="header-top d-flex flex-column">
            <div className="card-header-right-icon align-items-end">
              <div className="card-header-right-icon">
                <Btn
                  attrBtn={{
                    color: "light-primary",
                    className: "btn badge-light-primary",
                    onClick: () => setPrescriptionForm(!prescriptionForm),
                  }}
                >
                  + Add Prescription
                </Btn>
              </div>
            </div>
            <div>
              {prescriptionForm && (
                <Fragment>
                 
                  <Form
                    onSubmit={handleSubmit(onSubmit)}
                    className="form-bookmark needs-validation"
                  >
                    <Row className="d-flex align-items-center">
                      <Col>
                        <FormGroup className="mb-3">
                          <Label htmlFor="pharmacycategory">
                            {"Category"} <RequiredField />
                          </Label>
                          <select
                            name="pharmacycategory"
                            className={`form-control digits ${
                              errors.pharmacycategory ? "is-invalid" : ""
                            }`}
                            id="pharmacycategory"
                            {...register("pharmacycategory", {
                              required: true,
                            })}
                          >
                            <option value="">Select Pharmacy Category</option>
                            {category.map((type) => (
                              <option key={type.id} value={type.id}>
                                {type.name}
                              </option>
                            ))}
                          </select>
                          {errors.pharmacycategory && (
                            <span className="text-danger">
                              Category is required
                            </span>
                          )}
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup className="mb-3">
                          <Label htmlFor="medicinename">
                            {"Medicine Name"} <RequiredField />
                          </Label>
                          <Controller
                            name="medicinename"
                            control={control}
                            defaultValue=""
                            rules={{ required: true }}
                            render={({ field }) => (
                              <Input
                                type="select"
                                id="medicinename"
                                {...field}
                                className={`form-control ${
                                  errors.medicinename ? "is-invalid" : ""
                                }`}
                              >
                                <option value="">Select Medicine</option>
                                {filteredPharmacy.map((pharmacy) => (
                                  <option key={pharmacy.id} value={pharmacy.id}>
                                    {pharmacy.sub_name}
                                  </option>
                                ))}
                              </Input>
                            )}
                          />
                          {errors.medicinename && (
                            <span className="text-danger">
                              Medicine Name is required
                            </span>
                          )}
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup className="mb-3">
                          <Label htmlFor="quantity">
                            {"Quantity"} <RequiredField />
                          </Label>
                          <input
                            className={`form-control ${
                              errors.quantity ? "is-invalid" : ""
                            }`}
                            id="quantity"
                            type="number"
                            name="quantity"
                            {...register("quantity", { required: true })}
                          />
                          {errors.quantity && (
                            <span className="text-danger">
                              Quantity is required
                            </span>
                          )}
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup className="mb-3">
                          <Label htmlFor="duration">{"Duration"}</Label>
                          <input
                            className={`form-control ${
                              errors.duration ? "is-invalid" : ""
                            }`}
                            id="duration"
                            type="number"
                            name="duration"
                            {...register("duration")}
                          />
                          {errors.duration && (
                            <span className="text-danger">
                              Duration is required
                            </span>
                          )}
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup className="mb-3">
                          <Label htmlFor="intake">
                            {"Intake"} <RequiredField />
                          </Label>
                          {["beforefood", "afterfood"].map((intake) => (
                            <Label key={intake} className="d-block d-flex">
                              <Controller
                                control={control}
                                name={intake}
                                render={({ field }) => (
                                  <Input
                                    type="checkbox"
                                    {...field}
                                    checked={field.value}
                                    className={`form-control checkbox_animated ${
                                      errors[intake] ? "is-invalid" : ""
                                    }`}
                                  />
                                )}
                              />
                              {intake.charAt(0).toUpperCase() + intake.slice(1)}
                            </Label>
                          ))}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <FormGroup className="mb-3">
                        <Label htmlFor="timeOfDay">{"Time of Day"}</Label>
                        <div className="d-flex flex-wrap gap-5 mt-3">
                          {["morning", "afternoon", "evening", "night"].map(
                            (time) => (
                              <Label key={time} className="d-block d-flex">
                                <Controller
                                  control={control}
                                  name={time}
                                  render={({ field }) => (
                                    <Input
                                      type="checkbox"
                                      {...field}
                                      checked={field.value}
                                      className={`form-control checkbox_animated ${
                                        errors[time] ? "is-invalid" : ""
                                      }`}
                                    />
                                  )}
                                />
                                {time.charAt(0).toUpperCase() + time.slice(1)}
                              </Label>
                            )
                          )}
                        </div>
                      </FormGroup>
                    </Row>
                    <Row>
                      <div className="text-end btn-mb">
                        <Button
                          className="secondary me-2"
                          onClick={() => {setPrescriptionForm(!prescriptionForm); reset(); setSelectedPrescription(null)}}
                        >
                          {Cancel}
                        </Button>
                        <Button
                          className="primary"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? "Submitting..." : Submit}
                        </Button>
                      </div>
                    </Row>
                  </Form>
                </Fragment>
              )}
            </div>
          </div>
        </CardHeader>}
        <CardBody className="pt-0 campaign-table">
          <div className="recent-table table-responsive currency-table">
            <Fragment>
              {selectedRows.length !== 0 && (
                <div
                  className={`d-flex align-items-center justify-content-between bg-light-info p-2`}
                >
                  <H4 attrH4={{ className: "text-muted m-0" }}>
                    Delet Selected Data..!
                  </H4>
                  <Btn
                    attrBtn={{ color: "danger", onClick: () => handleDelete() }}
                  >
                    Delete
                  </Btn>
                </div>
              )}
              <Table striped responsive>
      <thead>
        <tr>
          <th>#</th>
          <th>Date</th>
          <th>Prescription Name</th>
          <th>Quantity</th>
          <th>Duration</th>
          <th>M - A - E - N</th>
          <th>Intake</th>
          <th>Total</th>
          <th>Due</th>
          <th>Paid Amt</th>
         {permission?.edit_access && <th>Action</th>} 
          <th>View Prescription</th>
          <th>View Invoice</th>
        </tr>
      </thead>
      <tbody>
        {prescriptiontabledata.map((row, index) => (
          <tr key={index}>
            <td>{row.ind}</td>
            <td>{row.date}</td>
            <td>{row.prescriptionname.join(', ')}</td>
            <td>{row.quantity.join(', ')}</td>
            <td>{row.duration.join(', ')}</td>
            <td>{row.maen.join(', ')}</td>
            <td>{row.intake.join(', ')}</td>
            <td>{row.total}</td>
            <td>{row.due.join(', ')}</td>
            <td>{row.pay.join(', ')}</td>
            {permission?.edit_access && <td>{row.action}</td>}
            <td>{row.viewprescription}</td>
            <td>{row.viewinvoice}</td>
          </tr>
        ))}
      </tbody>
    </Table>
              {/* <DataTable
                data={prescriptiontabledata}
                columns={tableColumns}
                striped={true}
                center={true}
                pagination
                selectableRows
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleDelet}
                fixedHeader
                title="Prescription"
              /> */}
            </Fragment>
          </div>
        </CardBody>
      </Card>
    </Suspense>
  );
};

export default Prescription;
